import React from "react";
import { Button } from "@/components/ui/button";
import { GoogleLogo } from "@phosphor-icons/react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const GoogleSignInButton = ({ label = "Continue with Google" }) => {
  function go() {
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  }
  return (
    <>
      <div className="flex items-center gap-3 my-5" aria-hidden>
        <span className="flex-1 h-px bg-[#D0D2D5]" />
        <span className="text-[#6E7378] text-xs font-mono uppercase tracking-widest">or</span>
        <span className="flex-1 h-px bg-[#D0D2D5]" />
      </div>
      <Button
        type="button"
        onClick={go}
        data-testid="google-signin-btn"
        className="bb-pill w-full bg-white hover:bg-[#F2F3F4] text-[#0A0A0A] h-12 font-semibold border border-[#D0D2D5]"
      >
        <GoogleLogo size={18} weight="bold" className="mr-2" /> {label}
      </Button>
    </>
  );
};
